
function toggleClassHandler(e){
  // console.log('this', this)
  const classList = this.target.classList;

  if(classList.contains(this.class)){
    classList.remove(this.class);
  }else{
    classList.add(this.class);
  }
}

export function toggleBodyClass(class_name){
  return {
    class: class_name,
    target: document.body,
    handleEvent: toggleClassHandler
  }
}

export default () => {}
